<template>
    <HeaderTrangChuVue :visible="visible" />

    <div class="pa-3 content-home">
        <div class="row justify-space-between mb-3">
            <div class="font-medium">Chức năng chính</div>
            <!-- <div class="font-medium" style="color: #03a9f4">Xem tất cả</div> -->
        </div>
        <div
            v-for="(item, index) in DanhSachChucNang"
            :key="index"
            class="danh-sach-chuc_nang pa-2 mb-3"
        >
            <div
                class="row justify-space-between list-chuc-nang"
                @click="ChonChucNang(item.to)"
            >
                <div class="font-16 font-medium">
                    <DxButton
                        type="default"
                        stylingMode="text"
                        :icon="`mdi ${item.icon}`"
                    />
                    {{ item.text }}
                </div>
                <div>
                    <DxButton
                        type="default"
                        stylingMode="text"
                        :icon="`mdi ${item.iconCommon}`"
                    />
                </div>
            </div>
        </div>

        <!-- <div class="font-medium mb-3">Xem gần đây</div>

        <div class="row danh-sach-xem-gan-day">
            <div
                v-for="(item, index) in XemGanDay"
                :key="index"
                class="xem-gan-day pa-2 row justify-space-around align-center"
            >
                <div class="font-16 font-medium">
                    <div class="text-xs-center">
                        <DxButton
                            type="default"
                            stylingMode="text"
                            :icon="`mdi ${item.icon}`"
                        />
                    </div>
                    <div class="text-xs-center">
                        {{ item.text }}
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { DxButton } from "devextreme-vue/";
import HeaderVue from "@/components/Header/Header.vue";
import HeaderTrangChuVue from "./components/HeaderTrangChu.vue";
export default {
    data() {
        return {
            visible: false,
            DanhSachChucNang: [
                {
                    id: 1,
                    icon: "mdi mdi-ticket",
                    to: "/Khai-Bao-Ve",
                    disable: false,
                    text: "Khai báo vé",
                    iconCommon: "mdi mdi-chevron-right",
                    role: null,
                },
                {
                    id: 2,
                    icon: "mdi mdi-chart-multiple",
                    to: "/Bao-Cao/Ve-Doanh-Nghiep-Tu-Khai-Bao",
                    disable: false,
                    text: "Vé doanh nghiệp tự khai báo",
                    iconCommon: "mdi mdi-chevron-right",
                    role: null,
                },
                // {
                //     id: 3,
                //     icon: "mdi mdi-ticket",
                //     to: "/Cho-Xe-Vao-Ra-Ben",
                //     disable: false,
                //     text: "Cho xe vào ra bến",
                //     iconCommon: "mdi mdi-chevron-right",
                //     role: "POS/ChoXeVaoRaBen",
                // },
                // {
                //     id: 4,
                //     icon: "mdi mdi-home-import-outline",
                //     to: "/Cho-Xe-Vao-Ben",
                //     disable: false,
                //     text: "Cho xe vào bến",
                //     iconCommon: "mdi mdi-chevron-right",
                //     role: "POS/ChoXeVaoBen",
                // },
                // {
                //     id: 5,
                //     icon: "mdi mdi-home-export-outline",
                //     to: "/Cho-Xe-Ra-Ben",
                //     disable: false,
                //     text: "Cho xe ra bến",
                //     iconCommon: "mdi mdi-chevron-right",
                //     role: "POS/ChoXeRaBen",
                // },
                // {
                //     id: 3,
                //     icon: "mdi mdi-cog",
                //     to: "/Cau-Hinh",
                //     disable: false,
                //     text: "Cấu hình phát hành vé",
                //     iconCommon: "mdi mdi-chevron-right",
                // },
                // {
                //     id: 4,
                //     icon: "mdi mdi-chart-multiple",
                //     to: "/",
                //     disable: false,
                //     text: "Báo cáo",
                //     iconCommon: "mdi mdi-chevron-right",
                // },
            ],

            XemGanDay: [
                // {
                //     id: 1,
                //     icon: "mdi mdi-send",
                //     to: "/",
                //     disable: false,
                //     text: "Điều độ",
                //     iconCommon: "mdi mdi-chevron-right",
                // },
                // {
                //     id: 2,
                //     icon: "mdi mdi-archive-outline",
                //     to: "/",
                //     disable: true,
                //     text: "Quản lý đơn hàng",
                //     iconCommon: "mdi mdi-chevron-right",
                // },
                // {
                //     id: 3,
                //     icon: "mdi mdi-chart-multiple",
                //     to: "/",
                //     disable: false,
                //     text: "Báo cáo",
                //     iconCommon: "mdi mdi-chevron-right",
                // },
                // {
                //     id: 2,
                //     icon: "mdi mdi-send",
                //     to: "/",
                //     disable: false,
                //     text: "Điều độ",
                //     iconCommon: "mdi mdi-chevron-right",
                // },
                // {
                //     id: 2,
                //     icon: "mdi mdi-archive-outline",
                //     to: "/",
                //     disable: true,
                //     text: "Quản lý đơn hàng",
                //     iconCommon: "mdi mdi-chevron-right",
                // },
                // {
                //     id: 3,
                //     icon: "mdi mdi-chart-multiple",
                //     to: "/",
                //     disable: false,
                //     text: "Báo cáo",
                //     iconCommon: "mdi mdi-chevron-right",
                // },
            ],
        };
    },

    methods: {
        scrollTop: function () {
            this.intervalId = setInterval(() => {
                if (window.pageYOffset === 0) {
                    clearInterval(this.intervalId);
                }
                window.scroll(0, window.pageYOffset - 50);
            }, 20);
        },
        scrollListener: function (e) {
            this.visible = window.scrollY > 40;
            if (this.visible) {
            }
        },
        ChonChucNang(to) {
            this.$router.push(to);
        },
        KiemTraQuyenChucNang() {
            this.DanhSachChucNang = this.DanhSachChucNang.filter((item) => {
                // if (item.role) {
                //     return this.$Helper.KiemTraQuyen(item.role);
                // }
                return true;
            });
        },
    },
    created() {
        this.KiemTraQuyenChucNang();
    },
    mounted: function () {
        window.addEventListener("scroll", this.scrollListener);
    },
    beforeDestroy: function () {
        window.removeEventListener("scroll", this.scrollListener);
    },
    components: {
        HeaderVue,
        HeaderTrangChuVue,
        DxButton,
    },
};
</script>
<style scoped>
.danh-sach-chuc_nang {
    border-radius: 50px;
    box-shadow: 0px 2px 9px #dadce0;
    background-color: #fff;
}
.danh-sach-xem-gan-day {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 16px;
}
.xem-gan-day {
    height: 88px;
    border-radius: 10px;
    box-shadow: 0px 2px 9px #dadce0;
    background-color: #fff;
}
.content-home {
    padding-top: 148px !important;
}

.header img {
    width: 148px;
    height: 32px;
}
::v-deep .custom-btn-white-color i.dx-icon {
    color: white;
}
.list-chuc-nang {
    cursor: pointer;
}
</style>
